import NotificationsPage from "components/pages/NotificationsPage";

export default function CaptureNotifiLimAlertAdded(props) {
    return <NotificationsPage />
}